const s3BaseUrl = "https://hiring-assistant-assets.s3.ap-south-1.amazonaws.com";

const appName = "QualifyMe.ai";
const appLogo = `${s3BaseUrl}/qualifyme_light.png`;

export { s3BaseUrl, appName, appLogo };
